<template>
  <div class="page" v-loading="loading">
    <el-form :model="form" label-width="100px" ref="form">
      <el-row>
        <el-col :span="6">
          <el-form-item label="条形码" prop="code">
            <el-input v-model="form.code" placeholder="请输入"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="商品状态" prop="type">
            <el-select v-model="form.type" placeholder="请选择">
              <el-option label="全部" :value="-1"></el-option>
              <el-option label="在途" :value="0"></el-option>
              <el-option label="出库/迁移库" :value="1"></el-option>
              <el-option label="异常" :value="2"></el-option>
              <el-option label="待售" :value="3"></el-option>
              <el-option label="在售" :value="4"></el-option>
              <el-option label="已售" :value="5"></el-option>
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>
      <el-form-item>
        <div class="flex">
          <el-button type="primary" @click="getData">查询</el-button>
          <el-button @click="resetForm">重置</el-button>
          <toolbar class="mgl10" :buttonList="buttonList_toolBar" @callFunction="callFunction">
          </toolbar>
        </div>
      </el-form-item>
    </el-form>
    <div>
      <span class="label">商品id: </span><span class="value" v-if="tableData.length>0">{{tableData[0].spuId}}</span>&nbsp;
      <span class="label">商品规格id: </span><span class="value">{{$route.query.skuId}}</span>&nbsp;
      <!-- <span class="label">仓库名 / Id: </span><span class="value">{{$route.query.warehouseName}} /
        {{$route.query.warehouseId}}</span> -->
      <span class="label">仓库名: </span><span class="value">{{$route.query.warehouseName}}</span>&nbsp;
      <span class="label">仓库id: </span><span class="value">{{$route.query.warehouseId}}</span>&nbsp;
      <span class="label">总条码数: </span><span class="value">{{total}}</span>
    </div>
    <el-table class="mgt20" border :data="tableData" style="width: 100%" :header-cell-style="{ 'text-align': 'center' }"
      :cell-style="{ 'text-align': 'center' }">
      <el-table-column prop="code" label="商品库码"></el-table-column>
      <el-table-column label="商品状态">
        <template slot-scope="scope">
          <span v-if="scope.row. warehouseType===0">在途</span>
          <span v-if="scope.row. warehouseType===1">出库/迁移库</span>
          <span v-if="scope.row. warehouseType===2">异常</span>
          <span v-if="scope.row. warehouseType===3">待售</span>
          <span v-if="scope.row. warehouseType===4">在售</span>
          <span v-if="scope.row. warehouseType===5">已售</span>
        </template>
      </el-table-column>
      <el-table-column prop="location" label="库位"></el-table-column>
      <el-table-column prop="notes" label="备注"></el-table-column>
      <el-table-column label="条形码信息">
        <template slot-scope="scope">
          <div v-if="scope.row.barcodeInfo">
            <P>生产企业：{{JSON.parse(scope.row.barcodeInfo).FirmName}} / {{JSON.parse(scope.row.barcodeInfo).FirmStatus}}
            </P>
            <P>品牌名称：{{JSON.parse(scope.row.barcodeInfo).BrandName}}</P>
            <P>商品名称：{{JSON.parse(scope.row.barcodeInfo).ItemName}} /
              {{JSON.parse(scope.row.barcodeInfo).ItemSpecification}}</P>
          </div>
          <!-- 企业状态FirmStatus -->
          <!-- 品牌名称BrandName -->
          <!-- 商品名称ItemName
          规格ItemSpecification -->
          <!-- 生产企业FirmName -->
        </template>
      </el-table-column>
      <el-table-column label="操作" width="180">
        <template slot-scope="scope">
          <el-button size="mini" v-for="(item, index) in buttonList_table" :key="index" :type="item.buttonType"
            @click="callFunctionRow(item, index, scope.row)">{{ item.displayName }}</el-button>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination class="pagination" @size-change="handleSizeChange" @current-change="handleCurrentChange"
      :current-page="PageIndex" :page-sizes="[10, 20, 30, 40, 50, 100]" :page-size="form.MaxResultCount"
      layout="total, sizes, prev, pager, next, jumper" :total="total">
    </el-pagination>
    <el-dialog :title="dialogForm.hasOwnProperty('id')?'编辑':'创建'" :visible.sync="dialogVisible" width="40%"
      :before-close="handleClose" :close-on-click-modal="false">
      <el-form :model="dialogForm" label-width="80px" ref="dialogForm" :rules="rules">
        <el-form-item label="商品状态" prop="warehouseType">
          <el-select v-model="dialogForm.warehouseType" placeholder="请选择">
            <el-option label="在途" :value="0"></el-option>
            <el-option label="出库/迁移库" :value="1"></el-option>
            <el-option label="异常" :value="2"></el-option>
            <el-option label="待售" :value="3"></el-option>
            <el-option label="在售" :value="4"></el-option>
            <el-option label="已售" :value="5"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="库位" prop="location">
          <el-input v-model="dialogForm.location" placeholder="请输入">
          </el-input>
        </el-form-item>
        <el-form-item label="备注" prop="notes">
          <el-input type="textarea" :autosize="{ minRows: 4 }" v-model="dialogForm.notes" placeholder="请输入">
          </el-input>
        </el-form-item>
        <el-form-item label="条形码" prop="items" v-if="!dialogForm.hasOwnProperty('id')">
          <el-input type="textarea" :autosize="{ minRows: 4 }" v-model="dialogForm.items" placeholder="请输入条形码(用,隔开)">
          </el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="handleClose">取 消</el-button>
        <el-button type="primary" @click="handleSure">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import {
  GetAllByWarehouse,
  WarehouseCodeBatchCreate,
  WarehouseCodeUpdate,
  WarehouseCodeDelete,
} from "../../api/api";
import { getButtonList } from "../../promissionRouter";
import Toolbar from "../../components/Toolbar";
export default {
  components: { Toolbar },
  data() {
    return {
      form: {
        SkuId: this.$route.query.skuId,
        SkipCount: 0,
        MaxResultCount: 10,
        type: -1,
        code: ""
      },
      PageIndex: 1, //页码
      loading: false,
      tableData: [],
      total: 0,
      buttonList_toolBar: [],
      buttonList_table: [],
      dialogVisible: false,
      dialogForm: {
        warehouseType: "",
        location: "",
        notes: "",
        items: ""
      },
      rules: {
        warehouseType: [
          { required: true, message: '请选择商品状态', trigger: 'change' }
        ], items: [
          { required: true, message: '请输入条形码', trigger: 'blur' },
        ],
      }
    };
  },
  created() {
    this.queryData()
  },
  mounted() {
    let routers = window.localStorage.router
      ? JSON.parse(window.localStorage.router)
      : [];
    var buttonList = getButtonList(this.$route.path, routers);
    if (buttonList && buttonList.length > 0) {
      this.buttonList_toolBar = buttonList.filter((item) => {
        return item.buttonShow === 10;
      })
    }
    const tableButtonList = buttonList.filter((item) => {
      return item.buttonShow === 20;
    });
    this.buttonList_table = tableButtonList;
  },
  methods: {
    queryData() {
      // console.log(JSON.parse("{\"status\":\"200\",\"message\":\"查询成功！\",\"Barcode\":\"06907992514932\",\"ItemName\":\"舒化无乳糖牛奶-高钙型\",\"ItemClassCode\":\"50131702\",\"BrandName\":\"伊利\",\"ItemSpecification\":\"220ml\",\"ItemWidth\":\"0\",\"ItemHeight\":\"0\",\"ItemDepth\":\"0\",\"codeSource\":\"china\",\"FirmName\":\"内蒙古伊利实业集团股份有限公司\",\"ItemGrossWeight\":\"0\",\"Batch\":\"\",\"FirmAddress\":\"内蒙古自治区呼和浩特市金山开发区金山大街1号\",\"FirmStatus\":\"有效\",\"import_importers_name\":null,\"Image\":[]}"))
      this.loading = true
      this.form.SkipCount = (this.PageIndex - 1) * this.form.MaxResultCount;
      GetAllByWarehouse(this.form).then(res => {
        if (res.data.success) {
          this.tableData = res.data.result.items
          this.total = res.data.result.totalCount
        }
        setTimeout(() => {
          this.loading = false
        }, 500)
      })
    },
    handleSizeChange(val) {
      this.form.MaxResultCount = val
      this.queryData()
    },
    handleCurrentChange(val) {
      this.PageIndex = val
      this.queryData()
    },
    getData() {
      this.PageIndex = 1
      this.queryData()
    },
    resetForm() {
      this.PageIndex = 1
      this.form.MaxResultCount = 10
      this.$refs["form"].resetFields();
      this.queryData()
    },
    callFunction(item) {
      this[item.buttonFunc](this, item);
    },
    callFunctionRow(item, index, row) {
      this[item.buttonFunc](item, index, row);
    },
    batchCreate() {
      this.dialogVisible = true
      this.dialogForm = {
        skuId: this.$route.query.skuId,
        warehouseId: this.$route.query.warehouseId,
        warehouseType: "",
        location: "",
        notes: "",
        items: ""
      }
    },
    handleClose() {
      this.dialogVisible = false
      this.$refs["dialogForm"].resetFields();
    },
    handleSure() {
      this.$refs.dialogForm.validate((valid) => {
        if (valid) {
          if (!this.dialogForm.hasOwnProperty('id')) {
            let params = { ...this.dialogForm, items: this.dialogForm.items.split(",") }
            WarehouseCodeBatchCreate(params).then(res => {
              if (res.data.success) {
                this.queryData()
                this.$message.success("创建成功");
                this.handleClose()
              } else {
                this.$message.error(res.data.error.message);
              }
            })
          } else {
            WarehouseCodeUpdate(this.dialogForm).then(res => {
              if (res.data.success) {
                this.queryData()
                this.$message.success("编辑成功");
                this.handleClose()
              } else {
                this.$message.error(res.data.error.message);
              }
            })
          }
        } else {
          return false;
        }
      });
    },
    handleEditor(item, index, row) {
      this.dialogVisible = true
      this.dialogForm = {
        warehouseType: row.warehouseType,
        locaion: row.locaion,
        notes: row.notes,
        id: row.id
      }
    },
    handleDelete(item, index, row) {
      this.$confirm('是否确认删除?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        WarehouseCodeDelete({ Id: row.id }).then(res => {
          if (res.data.success) {
            this.$message.success("删除成功");
            this.queryData()
          } else {
            this.$message.error(res.data.error.message);
          }
        })
      }).catch(() => {

      });
    },
  }
};
</script>
<style scoped>
.label {
  font-size: 14px;
  color: red;
  line-height: 1;
}

.value {
  font-size: 14px;
  color: green;
  line-height: 1;
}
</style>
